import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AiChatRequest, AiChatRequestType, AiResponseType } from '@panaya/ai-chat/domain';
import { ProjectStore } from '@frontend-site/shared/core';

type OptionalParams = { params?: { [param: string]: string | number | boolean } };

@Injectable({
    providedIn: 'root'
})
export class AiChatService implements AiChatRequest {
    private readonly http = inject(HttpClient);
    private readonly projectStore = inject(ProjectStore);

    public request<Response extends AiResponseType>({ method, url, options }: AiChatRequestType): Observable<Response> {
        const requestOptions: typeof options & OptionalParams = {
            ...options
        };

        const projectId = this.projectStore.projectId;
        if (projectId) {
            requestOptions.params = { projectId };
        }

        return this.http.request<Response>(method, url, requestOptions);
    }
}
